module.exports = __webpack_public_path__ + "img/geo-logo.04fef034.png";